import { checkPermissionRoleScreen } from '../main';

function createRoute(path, name, typeRole, component) {
    return {
        path: path,
        name: name,
        beforeEnter: (to, from, next) => {
            return next(checkPermissionRoleScreen(typeRole));
        },
        component: component
    };
}
const routes = [
    createRoute('/mail-invite', 'mailInviteList', 'type_admin', () => import('@/views/mailInvite/list.vue')),
    createRoute('/mail-invite/add', 'mailInviteAdd', 'type_admin', () => import('@/views/mailInvite/edit.vue')),
    createRoute('/mail-invite/edit', 'mailInviteEdit', 'type_admin', () => import('@/views/mailInvite/edit.vue'))
];
export default routes;
